import InfoTooltip from 'elements/tooltip/InfoTooltip'
import React from 'react'
import { useTranslate } from 'react-admin'
import {
  TooltipContainer,
  TooltipDescriptionCell,
  TooltipFooter,
  TooltipHeader,
  TooltipLabel,
  TooltipRow,
  TooltipTable,
} from '../ProjectConfigurations.styles'

interface SnowSimulationModeTooltipProps {
  canUseDynamicMode: boolean
}

export const SnowSimulationModeTooltip: React.FC<SnowSimulationModeTooltipProps> = ({ canUseDynamicMode }) => {
  const translate = useTranslate()

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
      <InfoTooltip
        placement="right"
        title={
          <TooltipContainer>
            <TooltipHeader>{translate('Snow Simulation Mode Options:')}</TooltipHeader>
            <TooltipTable>
              <TooltipRow>
                <TooltipLabel>{translate('Fixed Percentage')}</TooltipLabel>
                <TooltipDescriptionCell>
                  {translate(
                    'Uses the manual snow loss percentage value specified in the Snow Loss (%) field. This value is always applied regardless of weather data. Available for all SAM calculator versions.'
                  )}
                </TooltipDescriptionCell>
              </TooltipRow>
              {canUseDynamicMode && (
                <TooltipRow>
                  <TooltipLabel>{translate('Dynamic')}</TooltipLabel>
                  <TooltipDescriptionCell>
                    {translate(
                      'Automatically uses physics-based snow modeling from weather data when available. If the weather file contains snow depth data, the physics model calculates snow losses dynamically. If no snow data is present, falls back to the manual percentage specified in Snow Loss (%). Only available with SAM 2025 R1 calculator in supported regions.'
                    )}
                  </TooltipDescriptionCell>
                </TooltipRow>
              )}
            </TooltipTable>
            <TooltipFooter>
              {translate(
                'The snow simulation mode determines how snow losses are calculated. Fixed Percentage provides consistent, predictable losses and works with all SAM versions. Dynamic mode adapts to actual weather conditions when snow depth data is available, but is only supported in SAM 2025 R1 for supported regions (US, GB, AU, NZ, and Europe West).'
              )}
            </TooltipFooter>
          </TooltipContainer>
        }
        severity="info"
        size="small"
      />
    </div>
  )
}
